import { createContext, useContext } from "react";

export const defaultContent = {
  contact: {
    phone_display: "+91-70650-28801",
    whatsapp: "917065028801",
    email: "info.allcov@gmail.com",
    address: "Ground Floor, D-9, Vyapar Marg, Sector 3, Noida, Uttar Pradesh 201301",
    hours: "Monday to Saturday, 10 AM to 7 PM",
    maps_url: "",
    instagram: "",
    linkedin: "",
  },
  gst_note: "+ 18% GST",
  home_chips: {
    brand: "Website from ₹14,999 · Logo from ₹4,999",
    whatsapp: "Setup from ₹5,000 + ₹1,500/month",
    sops: "SOP pack ₹9,999 · Executive from ₹20,000/month",
  },
  packages: [],
  work: [],
  faqs: { home: [], "brand-website": [], automation: [], sops: [] },
  quikpik: {
    status: "Pilot",
    area: "Now onboarding cafes in Raj Nagar and RDC, Ghaziabad",
    offer: "Free for the first 30 days. After that, a small monthly fee plus a share of app orders, shared in writing before you sign.",
    wa_message: "Hi Allcov, I want to partner with Quikpik for my cafe",
  },
  announcement: { enabled: false, text: "", link: "" },
};

/* Fallbacks used only if the API is unreachable — never render blank */
export const fallbackChips = { ...defaultContent.home_chips };

export const ContentContext = createContext(defaultContent);
export const useContent = () => useContext(ContentContext);

export const waLink = (c, text) => {
  const num = String(c?.contact?.whatsapp || "").replace(/\D/g, "");
  return `https://wa.me/${num}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};

export const telLink = (c) => `tel:+${String(c?.contact?.whatsapp || "").replace(/\D/g, "")}`;

export const mailLink = (c) => `mailto:${c?.contact?.email || ""}`;

export const pkgPrice = (p) => {
  if (p.unit === "from") return `from ${p.price}`;
  if (p.unit === "/month") return `${p.price}/month`;
  return p.price;
};

export const serviceGroups = [
  { key: "brand", label: "Brand & Website" },
  { key: "whatsapp", label: "WhatsApp & AI" },
  { key: "sops", label: "SOPs & Operations" },
  { key: "quikpik", label: "Quikpik" },
];

export const sortedPackages = (c, group) =>
  (c?.packages || [])
    .filter((p) => p.group === group && p.visible !== false)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

export const chipFor = (c, key) => {
  const custom = c?.home_chips?.[key]?.trim();
  if (custom) return custom;
  const ticks = (c?.packages || [])
    .filter((p) => p.group === key && p.visible !== false && p.homepage)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  if (!ticks.length) return fallbackChips[key] || "";
  return ticks.map((p) => p.chip_text?.trim() || `${p.name} ${pkgPrice(p)}`).join(" · ");
};

export const visibleWork = (c, homeOnly = false) =>
  (c?.work || [])
    .filter((w) => w.visible !== false && (!homeOnly || w.show_home))
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

export const faqsFor = (c, page) => c?.faqs?.[page] || [];
